import React from "react";

import { App } from "@/components/App/App";
import { MainPage } from "@/pages/main/MainPage";
import { PlaygroundPage } from "@/pages/playground/PlaygroundPage";
import { RefProgramPage } from "@/components/Conditions/RefProgramPage";
import { ConditionsList } from "@/components/Conditions/ConditionsList";
import { ReferralMultiplierPage } from "@/pages/referralMultiplier/ReferralMultiplierPage";
import { BloggerContestPage } from "@/pages/bloggerContest/BloggerContestPage";
import { sentryCreateBrowserRouter } from "@/utils/hooks/useSentry";

const routes = [
  {
    element: <App />,
    children: [
      {
        path: "/",
        element: <MainPage />,
      },
      {
        path: "/conditions",
        element: <ConditionsList />,
      },
      {
        path: "/conditions/:id",
        element: <RefProgramPage />,
      },
      {
        path: "/referral-multiplier",
        element: <ReferralMultiplierPage />,
      },
      {
        path: "/blogger-contest",
        element: <BloggerContestPage />,
      },
    ],
  },
  {
    path: "/playground",
    element: <PlaygroundPage />,
  },
];

export const router = sentryCreateBrowserRouter(routes);
